import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom';



export const CovidPage = () => {

  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

      <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage'>
          <img src={process.env.PUBLIC_URL + '/images/EVENTS/covidcompliant2.jpg'} alt="headImage" style={{ width: '100%', position:'relative' }} />  
          <h1>COVID-19 COMPLIANT</h1>
        </div>

        <div className='about-content-covid'>
          <div className='about-content-covid-content'>
            <h2 style={{ color:'#ffba03'}}>Your Safety is Our Top Priority</h2>
            <p>
            At Kombinasi Saudagar, we prioritize the health and safety of our clients and employees. We are committed to maintaining COVID-19 compliance across 
            all our operations, ensuring that all safety protocols and guidelines are strictly followed to provide a safe environment for everyone involved.
            </p>
              <div className='covid-steps-image-container'>
                <img src={process.env.PUBLIC_URL + '/images/COVID/wearmask.jpg'} alt="headImage" className='covid-steps-image' />
                <img src={process.env.PUBLIC_URL + '/images/COVID/washhands.jpg'} alt="headImage" className='covid-steps-image' />
                <img src={process.env.PUBLIC_URL + '/images/COVID/temp.jpg'} alt="headImage"  className='covid-steps-image'/>
                <img src={process.env.PUBLIC_URL + '/images/COVID/social.jpg'} alt="headImage" className='covid-steps-image' />
                <img src={process.env.PUBLIC_URL + '/images/COVID/vent.jpg'} alt="headImage" className='covid-steps-image' />
              </div>
          </div>
          <div className='about-content-covid-content-image'>
            <video autoPlay loop muted id='video' style={{ width: '100%', height: 'auto'}}>
              <source src={process.env.PUBLIC_URL + '/videos/ventilation_24.08.21.mp4'} type="video/mp4" />
            </video>
          </div>
        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>
    </div>
  );
}

export default CovidPage;
